import type { IAdViewLink } from "@finn-no/adview-provider-frontend-types";
import type { TrackerData } from "@finn-no/pulse-sdk";
import { ElementType, Intent, type ObjectPosition, TargetType } from "@mobility-item-page/utilities/client";

// Pulse payloads for the EV info section, defined in MBJ-321. `usePulse` adds the boilerplate.

export type EvExpandableName =
  | "batteryCapacity"
  | "consumption"
  | "rangePerKwh"
  | "batteryHealth"
  | "batteryWarranty"
  | "chargingCost"
  | "acChargePower"
  | "dcChargePower"
  | "chargingSpeed"
  | "batteryType"
  | "homeCharging";

type EvTooltipName = "wltpRange" | "batteryCapacity" | "plugType";

export const evSectionViewed = (): TrackerData => ({
  name: "EV info section",
  objectId: "MO_ev104",
  elementType: ElementType.Section,
  intent: Intent.Show,
});

export const evTooltipOpened = (name: EvTooltipName): TrackerData => ({
  name: "EV info tooltip",
  objectId: "MO_ev105",
  elementType: ElementType.Tooltip,
  intent: Intent.Open,
  objectExtras: { name },
});

export const evExpandableOpened = (name: EvExpandableName): TrackerData => ({
  name: "EV info expandable",
  objectId: "MO_ev106",
  elementType: ElementType.Accordion,
  intent: Intent.Open,
  objectExtras: { name },
});

/** Fired once per page load, for the first of the calculator's inputs the reader touches. */
export const evSavingsCalculatorUsed = (): TrackerData => ({
  name: "EV Savings calc",
  objectId: "MO_ev108",
  elementType: ElementType.Section,
  intent: Intent.Engagement,
});

export const evGuideLinkClicked = ({ uri, title }: IAdViewLink): TrackerData => ({
  name: "Read EV guide",
  objectId: "MO_ev107",
  elementType: ElementType.Link,
  intent: Intent.Open,
  target: {
    id: uri,
    name: title,
    type: TargetType.Article,
  },
});

/** `target.id: "id"` is copied verbatim from the dealer package's M_ev01, to keep the two comparable. */
export const evContactActionClicked = (position: ObjectPosition): TrackerData => ({
  name: "Send message",
  objectId: "M_ev01",
  elementType: ElementType.Button,
  intent: Intent.Create,
  position,
  target: {
    id: "id",
    type: TargetType.Message,
  },
});
